/* Pique & File — motif picker : sélection de 1 ou 2 motifs, propriétés de ligne du panier,
   présélection via l'URL, blocage de l'achat tant que le nombre de motifs voulu n'est pas atteint. */
if (!customElements.get('pf-motif-picker')) {
  customElements.define(
    'pf-motif-picker',
    class PfMotifPicker extends HTMLElement {
      connectedCallback() {
        this.count = parseInt(this.dataset.count, 10) || 1;
        this.selected = [];

        // un motif épuisé est rendu désactivé : il ne compte ni pour le clic ni pour la présélection
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.mobileQuery.addEventListener('change', () => this.renderGrid());
        this.cards = Array.from(this.querySelectorAll('[data-pf-motif-card]:not([disabled])'));
        this.soldOut = this.cards.length < this.count;
        this.hiddenInputs = Array.from(this.querySelectorAll('[data-pf-motif-input]'));
        this.recapElement = this.querySelector('[data-pf-motif-recap]');
        this.messageElement = this.querySelector('[data-pf-motif-message]');

        this.form = document.getElementById(this.dataset.productFormId);
        this.submitButton = this.form ? this.form.querySelector('.product-form__submit') : null;
        this.dynamicCheckout = this.form ? this.form.querySelector('.shopify-payment-button') : null;

        this.bar = this.querySelector('[data-pf-motif-bar]');
        this.barRecap = this.querySelector('[data-pf-motif-bar-recap]');
        this.barCta = this.querySelector('[data-pf-motif-bar-cta]');
        // la colonne produit porte une animation (transform) : un position: fixed à l'intérieur se
        // calerait sur elle et non sur l'écran — on sort la barre sous <body>
        if (this.bar && this.bar.parentElement !== document.body) document.body.appendChild(this.bar);

        this.cards.forEach((card) => {
          card.addEventListener('click', () => this.toggleCard(card));
        });

        // grille repliée sur téléphone + filtres par univers (Fleurs, Noël…)
        this.allCards = Array.from(this.querySelectorAll('[data-pf-motif-card]'));
        this.filters = Array.from(this.querySelectorAll('[data-pf-motif-filter]'));
        this.moreButton = this.querySelector('[data-pf-motif-more]');
        this.activeFilter = '';
        this.expanded = false;
        this.filters.forEach((button) => {
          button.addEventListener('click', () => this.applyFilter(button.dataset.pfMotifFilter));
        });
        if (this.moreButton) {
          this.moreButton.addEventListener('click', () => {
            this.expanded = true;
            this.renderGrid();
          });
        }

        if (this.form) {
          this.form.addEventListener('submit', this.handleFormSubmit.bind(this), true);
        }

        if (this.barCta) {
          this.barCta.addEventListener('click', this.handleBarCtaClick.bind(this));
        }

        // la barre fixe ne sert qu'à remplacer le bouton d'achat quand il est hors écran.
        // Ordinateur : seulement une fois le formulaire dépassé (au chargement il est sous la ligne de
        // flottaison, la barre masquerait la galerie). Téléphone : dès qu'il sort de l'écran.
        // Calcul au défilement plutôt qu'IntersectionObserver : passer de « sous l'écran » à « au-dessus »
        // n'est pas une transition pour l'observateur, la barre ne s'allumait jamais en desktop.
        if (this.bar && this.form) {
          let ticking = false;
          const updateBar = () => {
            ticking = false;
            const rect = this.form.getBoundingClientRect();
            const offscreen = rect.bottom < 0 || rect.top > window.innerHeight;
            const show = offscreen && (this.mobileQuery.matches || rect.bottom < 0);
            this.bar.classList.toggle('pf-motif-picker__bar--visible', show);
          };
          const requestUpdate = () => {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(updateBar);
          };
          window.addEventListener('scroll', requestUpdate, { passive: true });
          window.addEventListener('resize', requestUpdate);
          requestUpdate();
        }

        this.preselectFromUrl();
        this.render();
        this.renderGrid();
      }

      applyFilter(univers) {
        this.activeFilter = univers || '';
        this.filters.forEach((button) => {
          button.setAttribute('aria-pressed', String((button.dataset.pfMotifFilter || '') === this.activeFilter));
        });
        this.renderGrid();
      }

      // un filtre affiche tout son univers ; sans filtre, le téléphone ne montre que les 8 premiers
      // motifs (vedettes en tête) jusqu'au clic sur « Voir les N motifs ». Un motif choisi reste toujours visible.
      renderGrid() {
        const collapse = !this.activeFilter && !this.expanded && this.mobileQuery.matches;
        let shown = 0;
        let hiddenByCollapse = 0;

        this.allCards.forEach((card) => {
          const matches = !this.activeFilter || (card.dataset.univers || '').split(' ').includes(this.activeFilter);
          const isSelected = this.selected.some((motif) => motif.handle === card.dataset.motifHandle);
          let visible = matches;
          if (visible && collapse && shown >= 8 && !isSelected) {
            visible = false;
            hiddenByCollapse += 1;
          }
          if (visible) shown += 1;
          card.hidden = !visible;
        });

        if (this.moreButton) this.moreButton.hidden = hiddenByCollapse === 0;
      }

      preselectFromUrl() {
        const params = new URLSearchParams(window.location.search);
        const handles = [params.get('motif1'), params.get('motif2')].filter(Boolean);

        handles.forEach((handle) => {
          if (this.selected.length >= this.count) return;
          const card = this.cards.find((candidate) => candidate.dataset.motifHandle === handle);
          if (card && !this.selected.some((motif) => motif.handle === handle)) {
            this.selected.push({ handle, title: card.dataset.motifTitle, value: card.dataset.motifValue || card.dataset.motifTitle });
          }
        });
      }

      toggleCard(card) {
        const handle = card.dataset.motifHandle;
        const existingIndex = this.selected.findIndex((motif) => motif.handle === handle);

        if (existingIndex > -1) {
          this.selected.splice(existingIndex, 1);
        } else {
          if (this.selected.length >= this.count) {
            this.selected.shift();
          }
          this.selected.push({ handle, title: card.dataset.motifTitle, value: card.dataset.motifValue || card.dataset.motifTitle });
        }

        this.render();
      }

      isComplete() {
        return !this.soldOut && this.selected.length >= this.count;
      }

      render() {
        this.cards.forEach((card) => {
          const isSelected = this.selected.some((motif) => motif.handle === card.dataset.motifHandle);
          card.setAttribute('aria-pressed', String(isSelected));
          card.classList.toggle('pf-motif-picker__card--selected', isSelected);
        });

        this.hiddenInputs.forEach((input, index) => {
          input.value = this.selected[index] ? this.selected[index].value : '';
        });

        this.renderRecap();
        this.renderMessage();
        this.renderBar();
        this.toggleBuyControls(this.isComplete());
      }

      renderRecap() {
        if (!this.recapElement) return;

        const parts = [];
        for (let i = 0; i < this.count; i += 1) {
          parts.push(this.selected[i] ? this.selected[i].title : '…');
        }

        const label = this.count > 1 ? 'Ton duo' : 'Ton motif';
        this.recapElement.textContent = `${label} : ${parts.join(' + ')}`;
      }

      renderMessage() {
        if (!this.messageElement) return;

        const remaining = this.count - this.selected.length;
        if (remaining <= 0 || this.soldOut) {
          this.messageElement.textContent = '';
          this.messageElement.hidden = true;
          return;
        }

        this.messageElement.hidden = false;
        this.messageElement.textContent =
          remaining > 1 ? `Choisis encore ${remaining} motifs` : `Choisis encore ${remaining} motif`;
      }

      renderBar() {
        if (!this.bar) return;

        const complete = this.isComplete();
        this.bar.classList.toggle('pf-motif-picker__bar--complete', complete);

        if (complete) {
          const parts = [];
          for (let i = 0; i < this.count; i += 1) {
            parts.push(this.selected[i] ? this.selected[i].title : '…');
          }
          const label = this.count > 1 ? 'Ton duo' : 'Ton motif';
          if (this.barRecap) this.barRecap.textContent = `${label} : ${parts.join(' + ')}`;
          if (this.barCta) this.barCta.textContent = 'Ajouter';
        } else {
          if (this.barRecap) {
            this.barRecap.textContent = this.count > 1 ? `Choisis ${this.count} motifs` : 'Choisis ton motif';
          }
          if (this.barCta) this.barCta.textContent = 'Choisir';
        }
      }

      handleBarCtaClick() {
        if (this.isComplete()) {
          if (this.submitButton) this.submitButton.click();
          return;
        }

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const target = this.querySelector('.pf-motif-picker__grid') || this;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      }

      toggleBuyControls(complete) {
        if (this.submitButton) {
          if (complete) {
            this.submitButton.removeAttribute('disabled');
          } else {
            this.submitButton.setAttribute('disabled', 'disabled');
          }
        }

        if (this.dynamicCheckout) {
          this.dynamicCheckout.classList.toggle('pf-motif-picker-disabled', !complete);
        }
      }

      handleFormSubmit(event) {
        if (!this.isComplete()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.messageElement) this.messageElement.hidden = false;
        }
      }
    }
  );
}
